import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const PopoverTitle = declareString(
  "promptLibrary.workgroupMemberTeachingPopoverTitle",
  {
    text: "Explore prompts from your teams",
    comment: "Teaching Popover title to share a prompt to a workgroup.",
  }
);

export const PopoverMessage = declareStringWithPlaceholders(
  "promptLibrary.workgroupMemberTeachingPopoverMessage",
  {
    text: ({ action }) =>
      `Get started with prompts that others have shared to your team. Navigate to ${action} to get started.`,
    comment: "Teaching Popover message to share a prompt to a workgroup.",
    placeholders: {
      action: "Action to be displayed in bold is Team prompts",
    },
  }
);

export const PopoverGroupPrompts = declareString(
  "promptLibrary.workgroupMemberTeachingPopoverGroupPrompts",
  {
    text: "Team prompts",
    comment:
      "Action to be displayed in bold in promptLibrary.workgroupMemberTeachingPopoverMessage-resource instead of action-placeholder.",
  }
);

export const PopoverGotItButton = declareString(
  "promptLibrary.workgroupMemberTeachingPopoverGotItButtonLabel",
  {
    text: "Got it",
    comment: "Action to dismiss the teaching popover.",
  }
);
